var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 10.75L10.5461 14.421C10.6959 14.5709 10.7708 14.7465 10.7708 14.9479C10.7708 15.1493 10.6944 15.3297 10.5417 15.4891C10.3889 15.6352 10.2118 15.7083 10.0104 15.7083C9.80903 15.7083 9.63327 15.6331 9.48315 15.4828L4.52925 10.5227C4.45419 10.4476 4.39931 10.3661 4.36458 10.2785C4.32986 10.1908 4.3125 10.0968 4.3125 9.99663C4.3125 9.89643 4.32986 9.80249 4.36458 9.71481C4.39931 9.62713 4.45139 9.54857 4.52083 9.47913L9.47917 4.52079C9.63194 4.36801 9.81019 4.29163 10.0139 4.29163C10.2176 4.29163 10.3935 4.36801 10.5417 4.52079C10.6944 4.66895 10.7708 4.84487 10.7708 5.04856C10.7708 5.25227 10.6955 5.42941 10.545 5.57998L6.875 9.24996H15.2505C15.4629 9.24996 15.6409 9.32141 15.7845 9.46431C15.9282 9.60723 16 9.78431 16 9.99556C16 10.2068 15.9282 10.3854 15.7845 10.5312C15.6409 10.677 15.4629 10.75 15.2505 10.75H6.875Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.36c4696ff4f887ba1e159c9bb113442a.svg";
export { ForwardRef as ReactComponent };